export default {"highlightStarBoxWrapper":"yOaCH"};